var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-page',{staticClass:"om-app-404"},[_c('h1',{staticClass:"omapi-warning"},[_vm._v("404")]),_c('strong',[_vm._v("Uh oh!")]),_vm._v(" We can't find what you're looking for!\n")])}
var staticRenderFns = []

export { render, staticRenderFns }